import { useEffect, useState } from 'react';
import { TimeLogApi } from '../../../api';
import { useContainer } from '../../useContainer';

interface IGetSubmissionIntervals {
    userSub: string;
    projectId: string;
    startDate: string;
    endDate: string;
}

const useHttpGetSubmissionIntervals = (query: IGetSubmissionIntervals) => {
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const [data, setData] = useState<any[]>([]);

    useEffect(() => {
        const { exec, abort } = timeLogApi.getSubmissionIntervals({
            query: {
                ...query,
                startDate: encodeURIComponent(query.startDate),
                endDate: encodeURIComponent(query.endDate),
            },
            onSuccess: res => {
                setData(res.body);
            },
            onError: error => error,
        });

        if (query) exec();
        return abort;
    }, [JSON.stringify(query)]);

    return { data };
};

export default useHttpGetSubmissionIntervals;
